import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../../FlowConfigurationInputs/Table/Table';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import Input from "../../../FlowConfigurationInputs/EditableInput/Input";

function GetTechnician({ action, variables, setOpenVariable, variableRender, automVersionId }) {
    const { t } = useTranslation();
    // It is not newly created TR & EN  because it has the same labels.
    const label = 'CONTENT.CONFIGURATION-FORM.RESTFUL-WEB-SERVICE.';
    const headers = [label + 'ACTIVE', label + 'NAME', label + 'VALUE'];
    const options = {
        tableHeader: { headers, title: label + 'HEADER-FIELD' },
    };
    const [serviceDeskURI, setServiceDeskURI] = useState('');
    const [requestID, setRequestID] = useState('');


    return (
        <div>
            <div className="form-element">
                {t(label + 'SERVICE-DESK-URI')}
                <TextInput action={action} inputName="endpoint_uri" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} setServiceDeskURI={setServiceDeskURI} />
            </div>
            <div className="form-element">
                {t(label + 'TECHNICIAN-ID')}
                <TextInput action={action} inputName="request_id" variables={variables} setOpenVariable={setOpenVariable} isRequired={true} setRequestID={setRequestID} />
            </div>
            <div className="form-element">
                {t(label + 'ENDPOINT-URI')}
                <Input action={action} inputName="servicedesk_uri" serviceDeskURI={serviceDeskURI} setServiceDeskURI={setServiceDeskURI} setRequestID={setRequestID} requestID={requestID} endPointURI={"/api/v3/technicians/"} />
            </div>
            <div className="form-element">
                <Table action={action} inputName="headerParams" automVersionId={automVersionId} options={options.tableHeader} setOpenVariable={setOpenVariable} isRequired={false} />
            </div>
            <div className="form-element">
                {t('CONTENT.CONFIGURATION-FORM.REPEATABLE.REPEAT.ASSIGN_TO_VARIABLE')}
                <VariablePicker action={action} inputName="set" variables={variables} setOpenVariable={setOpenVariable} isRequired={false} variableRender={variableRender} />
            </div>
        </div>
    )
}

export default GetTechnician;
